class PackagesApiService {
  constructor() {
    this.baseURL = `${process.env.REACT_APP_API_BASE_URL || 'https://codelens.epoch.co/openshield/'}`;
  }

  async getAgentPackages(agentId) {
    try {
      const accessToken = localStorage.getItem('cognito_token');
      const headers = {
        'Content-Type': 'application/json',
      };
      
      if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
      }

      const response = await fetch(`${this.baseURL}api/packages/${agentId}`, {
        headers
      });
      
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('cognito_token');
          localStorage.removeItem('cognito_id_token');
          window.location.href = 'https://codelens.epoch.co/';
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching agent packages:', error);
      throw error;
    }
  }
}

const packagesApiService = new PackagesApiService();
export default packagesApiService;
